export const STATUS = {
  SCHEDULED: 'scheduled',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired'
}
